'use client';

import { isFilled } from "@prismicio/client";
import { PrismicNextLink, PrismicNextImage } from "@prismicio/next";
import { PrismicRichText } from "@prismicio/react";
import Link from "next/link";

/**
 * @typedef {import("@prismicio/client").Content.ProjectsListSlice} ProjectsListSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectsListSlice>} ProjectsListProps
 * @type {import("react").FC<ProjectsListProps>}
 */
const ProjectsList = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="max-w-400 mx-auto w-full px-8 md:px-16 mb-30">
        {isFilled.group(slice.primary.projects) && (
          <div className="flex flex-col md:flex-row justify-center gap-6">
            {slice.primary.projects.map((item, index) => (
              <div key={index} className="w-full md:w-1/4">
                {isFilled.link(item.project) && (
                  <Link href={`/projet/${item.project.uid}`} className="block group relative aspect-square overflow-hidden">
                    {/* Image desktop */}
                    {isFilled.image(item.project.data?.preview) && (
                      <div className="hidden md:block w-full h-full absolute inset-0 transition-opacity duration-300 group-hover:opacity-50">
                        <PrismicNextImage
                          field={{
                            ...item.project.data.preview,
                            alt: item.project.data.preview.alt || "Image d'illustration"
                          }}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}

                    {/* Image mobile */}
                    {isFilled.image(item.project.data?.preview_mobile) && (
                      <div className="block md:hidden w-full h-full absolute inset-0">
                        <PrismicNextImage
                          field={{
                            ...item.project.data.preview_mobile,
                            alt: item.project.data.preview_mobile.alt || "Image d'illustration"
                          }}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    )}

                    {/* Overlay desktop - apparaît au hover */}
                    <div className="hidden md:flex absolute inset-0 bg-[rgba(250,246,240,0.7)] opacity-0 group-hover:opacity-100 transition-opacity duration-300 items-center justify-center p-8">
                      <div className="text-left">
                        {/* Titre */}
                        {isFilled.keyText(item.project.data?.title) && (
                          <h2 className="text-xl font-semibold mb-2 uppercase text-graphite">{item.project.data.title}</h2>
                        )}

                        {/* Adresse */}
                        {isFilled.keyText(item.project.data?.adress) && (
                          <p className="text-sm mb-6 text-graphite">{item.project.data.adress}</p>
                        )}

                        <span className="cta-text">
                          Découvrir le projet
                        </span>
                      </div>
                    </div>

                    {/* Bouton mobile - toujours visible en bas */}
                    <div
                      className="md:hidden absolute bottom-0 left-0 w-full py-1 px-4 text-center"
                      style={{ background: "rgba(250, 246, 240, 0.90)" }}
                    >
                      <span className="cta-text">
                        {isFilled.keyText(item.cta) ? item.cta : "Découvrir le projet"}
                      </span>
                    </div>
                  </Link>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectsList;
